export default class PerfilSeguranca {
  constructor(id = null, nome = null, grupos = [], roles = []) {
    this.id = id
    this.nome = nome
    this.grupos = grupos
    this.roles = roles
  }
}
